<template>
  <div>
    <b-card header-tag="header" class="mb-3">
      <!-- 헤더 -->
      <div slot="header">
        <i class="fa fa-bars"></i> <strong>사이트 버전</strong>
      </div>
      <!-- 바디 -->
      <div>
        <b-row class="mb-2">
          <b-col cols="12" class="float-right">
            <!-- 검색어 -->
            <b-form inline class="float-right" @submit.prevent.stop="handleSearchClicked">
              <b-input-group>
                <b-form-select v-model="param.searchSiteId" variant="outline-secondary" class="mr-1" :options="siteOptions" @change="handleSiteChanged">
                </b-form-select>
                <b-input-group-prepend>
                  <b-form-select v-model="param.searchKind" variant="outline-secondary">
                    <option value="siteVersion">사이트버전</option>
                    <option value="appVersion">앱버전</option>
                  </b-form-select>
                </b-input-group-prepend>
                <b-form-input type="text" v-model="param.searchWord" placeholder="검색어 입력"/>
                <b-input-group-append>
                  <b-button v-ripple variant="outline-secondary" @click.stop="handleClearClicked">
                    <i class="fa fa-close"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button v-ripple variant="info" @click.stop="handleSearchClicked" class="ml-1">
                    <i class="fa fa-search"></i>
                  </b-button>
                </b-input-group-append>
                <b-input-group-append>
                  <b-button v-ripple variant="primary" @click.stop="handleAddClicked" class="ml-1">
                    <i class="fa fa-plus"></i>
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <!-- table -->
            <b-table outlined responsive no-local-sorting :foot-clone="true"
                     :fields="fields"
                     :items="items">
              <!-- 사이트ID -->
              <template slot="siteId" slot-scope="data">
                <b-form-select v-model="data.item.siteId"
                               :style="formBackgroundColor(data)"
                               :options="siteOptions"
                               :disabled="formFieldReadOnly(data)">
                </b-form-select>
              </template>
              <!-- 사이트 버전 -->
              <template slot="siteVersion" slot-scope="data">
                <b-form-input type="text" placeholder=""
                              v-model="data.item.siteVersion"
                              :style="formBackgroundColor(data)"
                              :disabled="formFieldReadOnly(data)"/>
              </template>
              <!-- 앱 버전 -->
              <template slot="appVersion" slot-scope="data">
                <b-form-input type="text" placeholder="앱 버전 정보 입력"
                              v-model="data.item.appVersion"
                              :style="formBackgroundColor(data)"/>
              </template>
              <!-- 만료년월일 -->
              <template slot="expireYmd" slot-scope="data">
                <b-form-input type="text" placeholder="yyyyMMdd"
                              v-model="data.item.expireYmd"
                              :style="formBackgroundColor(data)"/>
              </template>
              <!-- 캐쉬 확인 -->
              <template slot="cache" slot-scope="data">
                <b-button v-ripple variant="outline-secondary" @click="handleCacheClicked(data)" class="mr-1">
                  캐쉬 확인
                </b-button>
              </template>
              <!-- 액션 버튼 -->
              <template slot="action" slot-scope="data">
                <b-row>
                  <b-col class="text-right">
                    <b-button-group class="">
                      <b-button v-ripple variant="outline-primary" @click="handleSaveClicked(data)" class="mr-1">
                        <i class="fa fa-check"></i>
                      </b-button>
                      <b-button v-ripple variant="outline-danger" @click="handleDeleteClicked(data)">
                        <i class="fa fa-trash"></i>
                      </b-button>
                    </b-button-group>
                  </b-col>
                </b-row>
              </template>
            </b-table>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="10">
            <b-pagination size="md" v-model="paging.currentPage" :total-rows="paging.totalRows" :per-page="paging.perPage" @change="handleCurrentPageChanged">
            </b-pagination>
          </b-col>
          <b-col md="2">
            <b-form-select v-model="paging.perPage" :options="paging.pageOptions" @change="handlePerPageChanged" />
          </b-col>
        </b-row>

        <!-- 복사할 사이트 버전 선택 모달 -->
        <b-modal ref="copiedSiteVersionModal" size="md" :lazy="true" hide-header hide-footer no-close-on-backdrop no-close-on-esc>
          <copied-site-version
            :item="siteVersionItem"
            @apply="handleCopiedSiteVersionApplyClicked"
            @cancel="handleCopiedSiteVersionCancelClicked"></copied-site-version>
        </b-modal>

        <!-- 캐쉬확인 모달 -->
        <b-modal ref="cacheModal" size="lg" :lazy="true" :title="cacheModalTitle" :ok-only="true" ok-title="닫기" ok-variant="secondary">
          <b-row>
            <b-col>
              <b-form-textarea placeholder="캐쉬 내용" v-model="cachedDataFileInfo" :rows="5"></b-form-textarea>
            </b-col>
          </b-row>
        </b-modal>
      </div>
    </b-card>
  </div>
</template>

<script>
import copiedSiteVersion from './CopiedSiteVersion'

export default {
  components: {
    copiedSiteVersion
  },
  data () {
    return {
      param: {
        searchSiteId: '',
        searchKind: 'siteVersion',
        searchWord: null,
        page: 0,
        size: 0
      },
      fields: [
        { key: 'siteId', label: '사이트' },
        { key: 'siteVersion', label: '사이트버전' },
        { key: 'appVersion', label: '앱버전' },
        { key: 'expireYmd', label: '만료년월일' },
        { key: 'cache', label: '캐쉬 확인' },
        { key: 'action', label: ' ' }
      ],
      items: [],
      siteOptions: [],
      siteVersionOptions: [],
      siteVersionItem: {},
      cacheModalTitle: null,
      cachedDataFileInfo: null,
      paging: {
        currentPage: 1,
        perPage: 20,
        totalRows: 0,
        pageOptions: [ 10, 20, 50, 100 ]
      }
    }
  },
  mounted () {
    this.$http.get('/setting/sites')
      .then((response) => {
        let sites = response.data.result.sites
        let options = [{
          value: '',
          text: ' - 사이트 - ',
          country: null
        }]
        for (let i = 0; i < sites.length; i++) {
          options.push({
            value: sites[i].siteId,
            text: sites[i].siteName,
            country: sites[i].country
          })
        }
        this.$data.siteOptions = options
        // 목록조회
        this.fetchList()
      })
      .catch((error) => {
        this.$toasted.global.error(this.formatErrorMessage(error))
      })
  },
  methods: {
    // 사이트버전 목록 조회
    fetchList () {
      this.$data.param.page = this.$data.paging.currentPage - 1
      this.$data.param.size = this.$data.paging.perPage
      this.$http.get('/setting/sites/versions', { params: this.$data.param })
        .then((response) => {
          this.$data.items = response.data.result.sites
          this.$data.paging.totalRows = response.data.result.totalCount
        })
        .catch((error) => {
          this.$toasted.global.error(this.formatErrorMessage(error))
        })
    },
    // 폼 입력필드 백그라운드 설정 - 신규 입력필드인 경우 노란색으로 디스플레이
    formBackgroundColor (data) {
      if (data.item.isNewItem) {
        return 'background-color:#fafad2;'
      } else {
        return null
      }
    },
    // 폼필드 읽기전용여부 설정
    formFieldReadOnly (data) {
      if (data.item.isNewItem) {
        return false
      } else {
        return true
      }
    },
    // 입력값 검증
    validateInput (data) {
      if (data.item.siteId === '') {
        this.$toasted.global.info('사이트를 선택하세요.')
        return false
      }
      if (!data.item.siteVersion) {
        this.$toasted.global.info('사이트 버전을 입력하세요.')
        return false
      }
      if (data.item.expireYmd && data.item.expireYmd.length !== 8) {
        this.$toasted.global.info('만료년월일을 yyyyMMdd 포맷의 8자리로 입력하세요.')
        return false
      }
      return true
    },

    /**
     * <사이트 관리> 화면 이벤트 처리 메소드
     */
    // 사이트 콤보(검색조건) 변경시
    handleSiteChanged (value) {
      this.$nextTick(() => {
        this.$data.param.searchSiteId = value
        this.$data.paging.currentPage = 1
        this.fetchList()
      })
    },
    // 추가 버튼 클릭 시
    handleAddClicked () {
      // 입력 폼은 한건만 디스플레이 한다
      let find = false
      for (let idx in this.$data.items) {
        let item = this.$data.items[idx]
        if (item.isNewItem) {
          find = true
          break
        }
      }
      if (find) {
        this.$toasted.global.info('한건씩만 입력 가능합니다.')
        return false
      }
      // 빈 아이템 생성
      let emptyItem = {
        siteId: '',
        siteVersion: null,
        appVersion: null,
        expireYmd: null,
        copyBy: '-',
        isNewItem: true
      }
      // 배열 맨 앞에 추가한다
      this.$data.items.unshift(emptyItem)
    },
    // 검색어 삭제 버튼 클릭 시
    handleClearClicked (e) {
      this.$data.param.searchWord = null
    },
    // 조회 버튼 클릭 시
    handleSearchClicked (e) {
      this.$data.paging.currentPage = 1
      this.fetchList()
    },

    // 페이지 버튼 클릭 시
    handleCurrentPageChanged (value) {
      // 이 함수가 호출되는 시점에는 this.$data.paging.currentPage 값이 변경되기 전 값이므로 nextTick 을 이용한다
      this.$nextTick(() => {
        this.fetchList()
      })
    },
    // 페이지당 출력건수 변경 시
    handlePerPageChanged (value) {
      this.$data.paging.currentPage = 1
      // 이 함수가 호출되는 시점에는 this.$data.paging.perPage 값이 변경되기 전 값이므로 nextTick 을 이용한다
      this.$nextTick(() => {
        this.fetchList()
      })
    },

    // 캐쉬확인 버튼 클릭 시
    handleCacheClicked (data) {
      if (data.item.isNewItem) {
        this.$toasted.global.info('사이트 버전 저장 후 확인하세요.')
        return false
      }
      let url = '/setting/sites/' + data.item.siteId + '/versions/' + data.item.siteVersion + '/cache'
      this.$http.get(url)
        .then((response) => {
          // alert(JSON.stringify(response.data, null, 2))
          this.$data.cacheModalTitle = '캐쉬 확인 : ' + data.item.siteName + ' (' + data.item.siteVersion + ')'
          this.$data.cachedDataFileInfo = JSON.stringify(response.data, null, 2)
          this.$refs.cacheModal.show()
        })
        .catch((error) => {
          if (error.response.status === 404) {
            this.$toasted.global.info('등록된 데이터파일 정보가 없습니다.')
          } else {
            console.error(error.stack)
            this.$toasted.global.error(this.formatErrorMessage(error))
          }
        })
    },
    // 저장 버튼 클릭 시
    handleSaveClicked (data) {
      if (!this.validateInput(data)) {
        return false
      }
      let url = '/setting/sites/' + data.item.siteId + '/versions/' + data.item.siteVersion
      // 신규추가 버튼을 클릭하여 생성된 빈 데이터만 isNewItem 값이 true 임
      if (data.item.isNewItem) {
        this.$data.siteVersionItem = data.item
        this.$refs.copiedSiteVersionModal.show()
      } else {
        this.$http.put(url, data.item)
          .then((response) => {
            this.$emit('site-version-item-changed')
            this.$toasted.global.success('저장 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    },
    // 삭제 버튼 클릭 시
    handleDeleteClicked (data) {
      // 신규버튼을 눌러 디스플레이된 로우를 삭제하는 경우
      if (data.item.isNewItem) {
        for (let i = 0; i < this.$data.items.length; i++) {
          if (this.$data.items[i].isNewItem) {
            this.$data.items.splice(i, 1)
            break
          }
        }
        return false
      }
      // 실제 데이터를 삭제하는 경우
      let message = '삭제 작업은 취소가 불가능 하며, 데이터 파일 정보를 등록한 사이트 버전은 삭제되지 않습니다. \n\n정말로 ' + data.item.siteName + ' (' + data.item.siteVersion + ')을(를) 삭제 하시겠습니까? '
      if (confirm(message)) {
        this.$http.delete('/setting/sites/' + data.item.siteId + '/versions/' + data.item.siteVersion)
          .then((response) => {
            this.$emit('site-version-item-changed')
            this.$toasted.global.success('삭제 되었습니다.')
            this.fetchList()
          })
          .catch((error) => {
            this.$toasted.global.error(this.formatErrorMessage(error))
          })
      }
    },

    // 모달의 적용 버튼을 클릭
    handleCopiedSiteVersionApplyClicked (item) {
      this.$refs.copiedSiteVersionModal.hide()
      let idx = item.copyBy.lastIndexOf('-')
      if (idx > 0) {
        item.copySiteId = item.copyBy.substring(0, idx)
        item.copySiteVersion = item.copyBy.substring(idx + 1)
        item.copyBy = '-'
      }
      // 모달에서 선택된 버전 옵션과 함께 저장
      this.$http.post('/setting/sites/' + item.siteId + '/versions/' + item.siteVersion, item)
        .then((response) => {
          this.$emit('site-version-item-changed')
          this.$toasted.global.success('저장 되었습니다.')
          this.$data.siteVersionItem = {}
          this.fetchList()
        })
        .catch((error) => {
          this.$data.siteVersionItem = {}
          this.$toasted.global.error(this.formatErrorMessage(error))
        })
    },
    // 모달의 취소 버튼을 클릭
    handleCopiedSiteVersionCancelClicked (item) {
      this.$refs.copiedSiteVersionModal.hide()
      this.$data.siteVersionItem = {}
      item.copyBy = '-'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/SiteVersion.vue